import Forward from "@/views/Forward.vue";
import routerSurfaces from "@/router/surfaces";
import routerPartners from "@/router/partners";
import routerColors from "@/router/colors";
import routerRatios from "@/router/ratios";

export default (rootPath) => {
  return [
    {
      path: "banners",
      component: Forward,
      redirect: `${rootPath}/banners/list`,
      meta: { title: "Баннеры" },
      children: [
        {
          path: "list",
          component: () => import("@/views/table/BannersTable.vue"),
          meta: { title: "Список баннеров", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/BannersForm.vue"),
          meta: { title: "Создать баннер", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/BannersForm.vue"),
          meta: { title: "Редактировать баннер", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
    {
      path: "/surfaces",
      component: Forward,
      meta: { title: "Поверхности" },
      redirect: "/surfaces/list",
      children: routerSurfaces("/surfaces"),
    },
    {
      path: "/partners",
      component: Forward,
      meta: { title: "Партнеры" },
      redirect: "/partners/list",
      children: routerPartners("/partners"),
    },
    {
      path: "/colors",
      component: Forward,
      meta: { title: "Цвета" },
      redirect: "/colors/list",
      children: routerColors("/colors"),
    },
    {
      path: "/ratios",
      component: Forward,
      meta: { title: "Соотношение сторон" },
      redirect: "/ratios/list",
      children: routerRatios("/ratios"),
    },
  ];
};
